export default config => {
  const newConfig = config;
  newConfig.headers.Authorization = `Bearer ${sessionStorage.access_token}`;
  return Promise.resolve(newConfig);
};
